import { CustomIconName, Icon, theme } from '@ketch-com/deck'
import { Box, styled, Typography } from '@mui/material'

export type SummaryCardProps = {
  fieldName: string
  fieldValue?: string
  icon: CustomIconName
}

const CardBox = styled(Box)({
  display: 'flex',
  gap: '24px',
  minHeight: '49px',
  padding: '8px 16px',
  border: `1px solid ${theme.palette.Common.Divider}`,
  borderRadius: '8px',
  width: 'fit-content',
})

const TextBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
})

export const SummaryCard: React.FC<SummaryCardProps> = ({ fieldName, fieldValue, icon }) => {
  return (
    <CardBox>
      <TextBox>
        <Typography variant="smallBody" color={theme.palette.Text.Secondary}>
          {fieldName}
        </Typography>
        <Typography variant="smallLabel" color={theme.palette.Text.Primary}>
          {fieldValue}
        </Typography>
      </TextBox>
      <Icon name={icon} width="20px" height="20px" iconColor={theme.palette.Black.o56} />
    </CardBox>
  )
}
